module.exports = __webpack_public_path__ + "static/media/citystay2.355c6929.jpg";